exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toolKitTitle{color:#38404f;font-size:20px;font-weight:700;line-height:22px;cursor:pointer}.toolKitTitle a{color:#38404f;padding-right:8px}.toolKitTitle a:hover{text-decoration:none;color:#38404f}.toolKitText{font-size:14px;color:#38404f}.toolKitText a{color:#4d7cfe}.toolKitText a:hover{text-decoration:none;color:#4d7cfe}.card-body{padding:5px!important}.card-body p{margin:0}", ""]);

// exports
